import { Check } from '@mui/icons-material';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
} from '@mui/material';
import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from '../../services';

const ApproveStudyRequest: FC<{ callback: (value: boolean) => void }> = ({
	callback,
}) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = useCallback(
		(approve: boolean) => {
			callback(approve);
			setOpen(false);
		},
		[setOpen, callback]
	);

	return (
		<>
			<IconButton
				onClick={handleClickOpen}
				title={t('Approve request')}
				color="success"
			>
				<Check />
			</IconButton>
			<Dialog
				open={open}
				onClose={() => handleClose(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{t('Approve request')}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{t(
							'I checked the request and I approve to start registration process.'
						)}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => handleClose(false)}>{t('No')}</Button>
					<Button onClick={() => handleClose(true)} autoFocus>
						{t('Yes')}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default ApproveStudyRequest;
